import { BROADCAST_SET_PRESENTER_DISMISSED } from 'actions/Types';

function setPresenterDismissed(isDismissed) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_PRESENTER_DISMISSED,
      payload: isDismissed
    };

    dispatch(action);
  };
}

export default setPresenterDismissed;
